import type {
  TypeGetInboundRequestProgressParams,
  TypeGetReceivingReportHistoriesParams,
  TypeGetRequestGoodsParams,
  TypePostRequestsRequestedParams,
  TypePostStatusRequestedParams,
} from '~/types/receive.types';

/**
 * [입고관리] React Query Key Factory
 */
export const receiveKeys = {
  all: ['receive'] as const,

  /** 필터 옵션 조회 (useGetFilterAll) */
  filterAll: (screenName: string) => [...receiveKeys.all, 'filterAll', screenName] as const,

  /** 입고요청 목록 조회 (POST /requests/requested) */
  requestsRequested: (ownerCode: string, params: TypePostRequestsRequestedParams) =>
    [...receiveKeys.all, 'requestsRequested', ownerCode, params] as const,

  /** 입고요청 상세 조회 (GET /requests/requested/:id) */
  requestsRequestedDetail: (ownerCode: string, requestId: string) =>
    [...receiveKeys.all, 'requestsRequestedDetail', ownerCode, requestId] as const,

  /** 입고상품추가 모달 > 상품 조회 (GET /request/goods) */
  requestGoods: (ownerCode: string, params: TypeGetRequestGoodsParams) =>
    [...receiveKeys.all, 'requestGoods', ownerCode, params] as const,

  /** 입고현황 목록 조회 (GET /receiving/:ownerCode/progress) */
  receivingProgress: (ownerCode: string, params: TypePostStatusRequestedParams) =>
    [...receiveKeys.all, 'receivingProgress', ownerCode, params] as const,

  /** 3PL 입고현황 목록 조회 (GET /receiving/:ownerCode/inbound-request/progress) */
  inboundRequestProgress: (ownerCode: string, params: TypeGetInboundRequestProgressParams) =>
    [...receiveKeys.all, 'inboundRequestProgress', ownerCode, params] as const,

  /** 입고 리포트 목록 조회 (GET /receiving/:ownerCode/report/histories) */
  reportHistories: (ownerCode: string, params: TypeGetReceivingReportHistoriesParams) =>
    [...receiveKeys.all, 'reportHistories', ownerCode, params] as const,
};
